import pubsub from "@viewlift/pubsub";
import PackageJson from '../../package.json';
import playerPackageJson from '@viewlift/player/package.json';
import { getStorageItem } from "../helpers/storageManager";
import { VISITOR } from "./Configuration";
const playerVersion = playerPackageJson.version
const version = PackageJson.version
var Media
export let VideoAnalyticsProviderWrapper


(function () {

  function VideoAnalyticsProvider(player, mediaInstance,entitlementData) {
    Media = mediaInstance
    if (!player) {
      throw new Error("Player reference cannot be null.")
    }
    //Constructor
    this._player = player;
    this._adComplete = false;
    this._entitlementData = entitlementData
    this._mediaTracker = Media.getInstance();
    this._isBufferComplete = true;
    if(!this?._mediaTracker) return

    this._installEventListeners();
  }

  VideoAnalyticsProvider.prototype.destroy = function () {
    console.log('Player event: DESTROYED');
    if (this._mediaTracker) {
      this._onUnload(); 
      this._mediaTracker.destroy();
      this._mediaTracker = null;
    }

    if (this._player) {
      this._player = null;
      this._uninstallEventListeners();
    }
  };

  VideoAnalyticsProvider.prototype._onLoad = function (payload) {
    if(!this?._mediaTracker) return
    console.log('Player event: VIDEO_LOAD');
    var videoInfo = this._entitlementData
    const isLiveStream = videoInfo?.gist?.streamingInfo?.isLiveStream || false
    var mediaInfo = Media.createMediaObject(videoInfo.gist.title, videoInfo.gist.id, !isLiveStream ? videoInfo.runtime : 0, Media.StreamType.VOD, Media.MediaType.Video);
    let data = this._formulatePayload({type: "VIDEO_LOAD", info : {}})
    this._mediaTracker.trackSessionStart(mediaInfo,data);
  };

  VideoAnalyticsProvider.prototype._onUnload = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: VIDEO_UNLOAD');
    this._mediaTracker.trackSessionEnd();
  };

  VideoAnalyticsProvider.prototype._onPlay = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: PLAY');
      if(!this._isBufferComplete) {
        this._isBufferComplete = true
        this._onBufferComplete()
      }else {
        this._mediaTracker.trackPlay();
      }
  };
  VideoAnalyticsProvider.prototype._onPause = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: PAUSE');
    this._mediaTracker.trackPause();
  };

  VideoAnalyticsProvider.prototype._onSeekStart = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: SEEK_START');
    this._mediaTracker.trackEvent(Media.Event.SeekStart, null, null);
  };

  VideoAnalyticsProvider.prototype._onSeekComplete = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: SEEK_COMPLETE');
    this._mediaTracker.trackEvent(Media.Event.SeekComplete, null, null);
  };

  VideoAnalyticsProvider.prototype._onBufferStart = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: BUFFER_START');
    this._isBufferComplete = false
    this._mediaTracker.trackEvent(Media.Event.BufferStart, null, null);
};

VideoAnalyticsProvider.prototype._onBufferComplete = function () {
  if(!this?._mediaTracker) return
    console.log('Player event: BUFFER_COMPLETE');
    this._mediaTracker.trackEvent(Media.Event.BufferComplete, null, null);
};

  VideoAnalyticsProvider.prototype._onAdStart = function (data) {
    if(!this?._mediaTracker) return
    console.log('Player event: AD_START');
    this._adComplete = false
    const { startTimeInSeconds: rawStartTime, ad, adIndex } = data?.adsData;
    const startTimeInSeconds = Math.round(rawStartTime);
    
    var _adBreakInfo = ad
    if(!_adBreakInfo) return
      var adBreakInfo = Media.createAdBreakObject(_adBreakInfo?.adTitle, startTimeInSeconds, startTimeInSeconds);
  
      var _adInfo = _adBreakInfo
      var resolver = _adInfo?.adSystem
      var creativeId = _adInfo?.creativeId
      var adInfo = Media.createAdObject(_adInfo?.adTitle, _adInfo?.adId, startTimeInSeconds,_adInfo?.durationInSeconds);
      let adContextData = this._formulatePayload({type: "AD", info : _adInfo})
      adContextData["resolver"] = resolver || "N/A"
      adContextData["creative"] = creativeId || "N/A"
      adContextData["advertiser"] = "N/A"
      adContextData["creativeName"] = "N/A"

    this._mediaTracker.trackEvent(Media.Event.AdBreakStart, adBreakInfo);
    this._mediaTracker.trackEvent(Media.Event.AdStart, adInfo, adContextData);
    this._onChapterStart(_adInfo, startTimeInSeconds, adIndex)
  };

  VideoAnalyticsProvider.prototype._onAdComplete = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: AD_COMPLETE');
    if(!this._adComplete) {
       console.log('Player event: AD_COMPLETED');
      this._mediaTracker.trackEvent(Media.Event.AdComplete);
      this._onChapterComplete()
      this._adComplete = true
    }
    // this._mediaTracker.trackEvent(Media.Event.AdBreakComplete);
    // this._onChapterComplete()
  };

  VideoAnalyticsProvider.prototype._onBreakComplete = function() {
    console.log('Player event: BREAKEND');
    this._onAdComplete()
    this._mediaTracker.trackEvent(Media.Event.AdBreakComplete);
  }

  VideoAnalyticsProvider.prototype._onChapterStart = function (_adInfo, startTimeInSeconds, adIndex) {
    if(!this?._mediaTracker) return
    console.log('Player event: CHAPTER_START');

    var _chapterInfo = _adInfo
    var chapterInfo = Media.createChapterObject(_chapterInfo.adTitle, adIndex + 1, _chapterInfo.durationInSeconds, startTimeInSeconds);
    let chapterContextData = this._formulatePayload({type: "CHAPTER", info : _chapterInfo})

    this._mediaTracker.trackEvent(Media.Event.ChapterStart, chapterInfo, chapterContextData);
  };

  VideoAnalyticsProvider.prototype._onChapterComplete = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: CHAPTER_COMPLETE');
    this._mediaTracker.trackEvent(Media.Event.ChapterComplete);
  };

  VideoAnalyticsProvider.prototype._onComplete = function () {
    if(!this?._mediaTracker) return
    console.log('Player event: COMPLETE');
    this._mediaTracker.trackComplete();
  };

  VideoAnalyticsProvider.prototype._onPlayheadUpdate = function () {
    if(!this?._mediaTracker) return
    // console.log('Player event: PLAYHEAD_UPDATE');
    const currentTime = this._player.currentTime();
    this._mediaTracker.updatePlayhead(currentTime);
    }

  VideoAnalyticsProvider.prototype._installEventListeners = function () {
    // Register as observers to various VideoPlayer events.
    const self = this
    let player = self._player
    player?.on("loadeddata", () => this._onLoad())
    player?.on("play", () => this._onPlay())
    player?.on("pause", () => this._onPause())
    player?.on("seeking", () => this._onSeekStart())
    player?.on("seeked", () => this._onSeekComplete())
    player?.on("waiting", () => this._onBufferStart())
    player?.on('timeupdate', () => this._onPlayheadUpdate());
    if(window?.cast?.framework) {
      player?.on('chromecastConnected', () => {
        console.log("chromecast connected")
        window.isCastDevice = true
      })
      player?.on('chromecastDisconnected', () => {
        console.log("chromecast disconnected")
        window.isCastDevice = false
      })
    }
    (function listensAdverts() {
      pubsub.subscribe("ad-event-handler",(data) => {
        switch (data?.adsData?.eventType) {
          case "firstQuartile":
            self._onAdStart(data)
            break;
          case "complete":
            self._onAdComplete()
            break;
          case "breakEnd":
            self?._onBreakComplete()
          default:
            //
        }
      })
      pubsub.subscribe("video-ends",() => {
      self._onComplete()
    })
      pubsub.subscribe("destroy-adobe-analytics-instance",() => {
      self?.destroy()
    })
    }())
};

VideoAnalyticsProvider.prototype._uninstallEventListeners = function () {
    // unregister as observers to various VideoPlayer events.
    const self = this
    let player = self._player
    player?.off("loadeddata", () => this._onLoad())
    player?.off("play", () => this._onPlay())
    player?.off("pause", () => this._onPause())
    player?.off("seeking", () => this._onSeekStart())
    player?.off("seeked", () => this._onSeekComplete())
    player?.off("waiting", () => this._onBufferStart())
    player?.off('timeupdate', () => this._onPlayheadUpdate())
    // Listens to ads events
    (function listensAdverts() {
      pubsub.unsubscribe("ad-event-handler",(data) => {
        switch (data?.adsData?.eventType) {
          case "firstQuartile":
            self?._onAdStart(data)
            break;
          case "complete":
            self._onAdComplete()
            break;
          case "breakEnd":
            self?._onBreakComplete()
            break;
          default:
            //
        }
      })
    }())
      pubsub.unsubscribe("video-ends",() => {
      self._onComplete()
      })
      pubsub.unsubscribe("destroy-adobe-analytics-instance",() => {
      self?.destroy()
    })
};
function getTimeSegment(date) {
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) {
    return "morning";
  } else if (hour >= 12 && hour < 17) {
    return "afternoon";
  } else if (hour >= 17 && hour < 22) {
    return "primetime";
  } else {
    return "latenight";
  }
}

function getStreamType(url) {
  if (!url || typeof url !== "string") return null;

  const lowerUrl = url.toLowerCase();

  if (lowerUrl.includes(".mpd")) {
    return "DASH";
  } else if (lowerUrl.includes(".m3u8")) {
    return "HLS";
  } else {
    return "MP4";
  }
}

function isMobileBrowser() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function getPlatformType() {
  if (navigator.userAgentData) {
  navigator.userAgentData.getHighEntropyValues(['platform', 'model', 'mobile'])
    .then(ua => {
      if (ua.mobile) {
        return "Mobile";
      } else {
        return "PC";
      }
    });
}

if (isMobileBrowser()) {
  return "Mobile";
} else {
  return "PC";
}
}

function getFormattedData(ms) {
    const now = ms ? new Date(ms * 1000) : new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const min = now.getMinutes().toString().padStart(2, '0');
    const hrs = now.getHours().toString().padStart(2, '0');
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const day = dayNames[now.getDay()]
    return {date : `${month}/${dd}/${year}`, 
            day, 
            hrs, 
            min, 
            year,
            now};
}
  VideoAnalyticsProvider.prototype._formulatePayload = function (data) {
    const { type, info } = data
   
    const seriesTitle = this._entitlementData?.mediaType === "EPISODIC" ? this._entitlementData?.series?.title : null
    const isFullscreen = this._player?.isFullscreen() ? " FullScreen" : "Normal";
    const isLiveStream = this._entitlementData?.streamingInfo?.isLiveStream || false
    const {date,hrs,day,min,now } = getFormattedData()
    const programmingType = this._entitlementData?.metadata?.filter((keys) => keys?.name === "programmingType")?.map((program) => program?.value)
    const videolanguage = this._entitlementData?.gist?.languageCode
    let monetizationModels = this._entitlementData?.monetizationModels?.map((plan) => plan?.type) || []
    var contextData = {
      "appVersion" : version,
      "videoapp": window?.app_data?.site?.siteInternalName,
      "playerVersion": playerVersion,
      "videoplatform" : "Web",
      "videoguid" : this._entitlementData?.gist?.id,
      "videoprogram" : seriesTitle || this._entitlementData?.gist?.title,
      "videotitle" : this._entitlementData?.gist?.title,
      "videoinitiate" : window?.videoinitiate || "Manual",
      "videodate" : date,
      "videoday" : day,
      "videohour" : `${hrs}:00`,
      "videominute" : min,
      "videoairdate" : getFormattedData(this._entitlementData?.publishDate).date,
      "videostatus" :  monetizationModels.includes("FREE") ? "Free" : "Premium",
      "videoplayerurl" : window?.location?.href || "",
      "videodomain" : window?.location?.origin || "",
      "videocallsign" : "N/A",
      "videocliptype" : "N/A",
      "videoscreen" : isFullscreen,
      "videorequestorid": window?.app_data?.appcmsPlatform?.tveSettings?.requestorID,
      "videolanguage" : videolanguage || "N/A",
      "videodaypart" : getTimeSegment(now),
      "videoplayertech" : getStreamType(this._player.currentSrc()),
      "videoresearchtitle" : this._entitlementData?.gist?.title,
      "ovp" : getPlatformType(),
      "videobroadcast" : isLiveStream ? "Broadcast" : "Digital",
      "videocrossdevice" : window?.isCastDevice ? "T" : "F",
      "videosport" : "N/A",
      "videoleague" : "N/A",
      "videocliptype" : programmingType?.length ? programmingType[0] : "N/A",
      "videocastsource" : "N/A",
      "videosponsor" : "N/A",
      "publisher" : VISITOR.MARKETING_CLOUD_ORG_ID //need clarrification
    } 
    if(this._entitlementData?.network) {
      contextData["videonetwork"] = this._entitlementData?.network
    }
    contextData[ADB.Media.VideoMetadataKeys.AssetId] = this._entitlementData?.gist?.id
    const AuthenticationStore = getStorageItem('AuthenticationStore')
    let userInfo = AuthenticationStore?.user
    if(userInfo?.tveMetadata?.mvpdProvider) {
      contextData["videomvpd"] = userInfo?.tveMetadata?.mvpdProvider
      contextData["videocallsign"] = userInfo?.tveMetadata?.mvpdProvider
      contextData["videopassguid"] = userInfo?.tveMetadata?.tveUserId
    }
    if(window.videotmsid) {
      contextData["videotmsid"] = window.videotmsid
    }

    if(this._entitlementData?.gist?.primaryCategory) {
      contextData["videosubcat1"] = this._entitlementData?.gist?.primaryCategory?.title
    }
    if(this._entitlementData?.categories?.length) {
      contextData["videosubcat2"] = this._entitlementData?.categories.map((cat) => cat.title).join(", ")
    }
    if(window?.epsNumber || window?.epsNumber === 0) {
      contextData["videoepnumber"] = window?.epsNumber
    }
    if (window?.videoseason) {
      contextData["videoseason"] = window.videoseason
    }
    return contextData
  }

  VideoAnalyticsProviderWrapper = VideoAnalyticsProvider
})();